module.exports = __webpack_public_path__ + "img/doc2.85a98995.svg";